import {
    TRAINERS_FAILURE,
    TRAINERS_REQUEST,
    TRAINERS_SUCCESS,
    TRAINERS_POST_SUCCESS,
    TRAINERS_DELETE_SUCCESS,
    TRAINERS_PATCH_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export default (state = initialState, action) => {
    const { type, data, trainer } = action;
    switch (type) {
        case TRAINERS_DELETE_SUCCESS: {
            const newData = state.data.filter(d => d.id !== trainer)
            return {
                ...state,
                data: [...newData]
            }
        }

        case TRAINERS_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(d => d.id === trainer.id ? trainer : d)
            }
        }

        case TRAINERS_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, trainer]
            }
        }

        case TRAINERS_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case TRAINERS_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case TRAINERS_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
